export const SET_FESTIVALS = 'SET_FESTIVALS';
export const SET_ADMIN_FESTIVALS = 'SET_ADMIN_FESTIVALS';
export const SET_ACTIVE_FESTIVAL = 'SET_ACTIVE_FESTIVAL';
export const SET_PAGINATION = 'SET_PAGINATION';

// initial state
const state = {
    list: {},
    adminList: {},
    active: {},
    pagination: {},
}

// getters
const getters = {
    festivals: state => state.list,
    adminFestivals: state => state.adminList,
    festivalPagination: state => state.pagination,
    festival: state => state.active
}

// actions
const actions = {

    getAdminFestivals: ({ commit, state }, payload) => {
        axios.get(laroute.route('api.admin.festivals'))
            .then((response) => {
                commit(SET_ADMIN_FESTIVALS, {
                    adminList: response.data.data
                });

                if (response.data.meta) {
                    commit(SET_PAGINATION, {
                        pagination: response.data.meta
                    });
                }
            })
    },

    getMoreAdminFestivals: ({ commit, state }, payload) => {

        axios.get(laroute.route('api.admin.festivals', { page: payload.page }))
            .then((response) => {
                commit(SET_ADMIN_FESTIVALS, {
                    adminList: response.data.data
                });

                commit(SET_PAGINATION, {
                    pagination: response.data.meta
                });

            })
    },

    getFestivals: ({ commit, state }, payload) => {
        axios.get(laroute.route('api.festivals.index'))
            .then((response) => {
                commit(SET_FESTIVALS, {
                    festivals: response.data.data
                });
            })
    },

    getFestival: ({ commit, state }, payload) => {

        let festival = payload.festival
        let router = payload.router

        axios.get(laroute.route('api.festivals.show', { festival: festival.id }))
            .then((response) => {
                commit(SET_ACTIVE_FESTIVAL, {
                    active: response.data.data
                });

                // Route after call
                router && router.push({ name: 'festival-edit', params: { id: festival.id } })
            })
    },

    setActiveFestival: ({ commit, state }, payload) => {
        commit(SET_ACTIVE_FESTIVAL, {
            active: payload
        })

    }
}

// mutations
const mutations = {
    [SET_FESTIVALS]: (state, payload) => {
        state.list = Object.assign({}, state.list, payload.festivals);
    },

    [SET_ADMIN_FESTIVALS]: (state, payload) => {
        state.adminList = Object.assign({}, state.adminList, payload.adminList);
    },

    [SET_PAGINATION]: (state, payload) => {
        state.pagination = Object.assign({}, state.pagination, payload.pagination);
    },

    [SET_ACTIVE_FESTIVAL]: (state, payload) => {
        state.active = Object.assign({}, state.active, payload.active);
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
